module.exports = __webpack_public_path__ + "static/sideImage-e932522b227d0947857d54441c3ec666.jpg";